import { navigationPaths } from 'data/constants';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { FC, useCallback } from 'react';
import { HotelTopPicksType } from 'types/types';

interface ITopPickCard {
  hotel: HotelTopPicksType;
}

const TopPickCard: FC<ITopPickCard> = ({
  hotel: { name, image, location, id },
}) => {
  const router = useRouter();
  const handleExploreOurHotelsClick = useCallback(() => {
    router.push(navigationPaths.OUR_HOTELS + `/${id}`);
  }, [id, router]);
  return (
    <div
      className="top-pick-card-container"
      id={id}
      onClick={handleExploreOurHotelsClick}
    >
      <div className="top-pick-card-container__imageWrapper">
        <Image
          src={image}
          alt={name}
          layout="fill"
          objectPosition="center"
          objectFit="cover"
          className="top-pick-card-container__image"
          sizes="(max-width: 768px) 320px, (max-width: 1024px) 100vw, 100vw"
        />
      </div>
      <div className="top-pick-card-container__gradientLayer">
        <div className="top-pick-card-container__description-text">{name}</div>
        <div className="top-pick-card-container__divider" />
        <div className="top-pick-card-container__location-text">{location}</div>
      </div>
    </div>
  );
};

export default TopPickCard;
